module.exports = __webpack_public_path__ + "img/oxford-bg-pc.0512f6e0.jpg";